import ImagesMainBannerInvestCollectEnjoyInvestCollectEnjoyBgWebp from '@/public/images/main-banner/invest-collect-enjoy/invest-collect-enjoy-bg.webp';
import ImagesMainBannerInvestCollectEnjoyInvestCollectEnjoyMainImageWebp from '@/public/images/main-banner/invest-collect-enjoy/invest-collect-enjoy-main-image.webp';

export {
  ImagesMainBannerInvestCollectEnjoyInvestCollectEnjoyBgWebp,
  ImagesMainBannerInvestCollectEnjoyInvestCollectEnjoyMainImageWebp,
};
